<template>
  <div class="header">
    <div class="collapseBtn" @click="$emit('toggleCollapse')">
      <i
        :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
        style="font-size: 22px; color: white"
      ></i>
    </div>
    <div class="title">智能调度系统</div>
    <div class="right">
      <div @click="toggleFullScreen">
        <i
          class="el-icon-full-screen"
          style="font-size: 22px; color: white"
        ></i>
      </div>
      <div style="margin-left: 16px">
        <el-avatar :size="35" :src="profilePicture"></el-avatar>
      </div>
      <div style="margin-left: 16px">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">退出登录</el-dropdown-item>
            <el-dropdown-item command="2">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <SetPassword ref="setPass"></SetPassword>
  </div>
</template>

<script>
import SetPassword from "./setPassword.vue";
import { logOut, queryOvertimeTask } from "@/common/api";

export default {
  name: "Header",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SetPassword,
  },
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    userName() {
      return JSON.parse(localStorage.getItem("userInfo"))?.name || "未登录";
    },
    profilePicture() {
      return (
        JSON.parse(localStorage.getItem("userInfo"))?.profilePicture ||
        "https://ts1.tc.mm.bing.net/th/id/OIP-C.4q3a69Kaw4mqI2rqpBaqsgHaD8?rs=1&pid=ImgDetMain&o=7&rm=3"
      );
    },
  },
  created() {
    // 轮询获取任务超时消息
    this.getList();
    this.timer = setInterval(() => {
      this.getList();
    }, 2 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    getList() {
      queryOvertimeTask().then((res) => {
        if (res.success) {
          if (res.data.taskCodes && res.data.taskCodes.length > 0) {
            let str = res.data.taskCodes.join(",");
            this.$notify({
              title: "注意",
              message: `当前有任务已超时,${str}`,
              type: "warning",
              duration: 30 * 1000,
            });
          }
        }
      });
    },
    handleCommand(e) {
      if (e == "1") {
        this.$confirm("是否确认退出此系统?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // let param = {
            //   userId: JSON.parse(localStorage.getItem("userInfo")).id,
            // };
            // logOut(param).then((res) => {
            //   if (res.success) {
            //     this.$successMsg("退出成功");
            //     localStorage.removeItem("userInfo");
            //     window.location.replace("/#/login");
            //   }
            // });
            this.$store.dispatch("user/logout");
            window.location.replace("/#/login");
          })
          .catch(() => {});
      }
      if (e == "2") {
        this.$refs.setPass.dialogFormVisible = true;
      }
    },
    requestFullScreen() {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari, Edge
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen();
      } else {
        this.$warnMsg("当前浏览器不支持全屏");
      }
    },
    // 退出全屏
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullScreen();
      } else {
        this.requestFullScreen();
      }
    },
    // 判断是否处于全屏状态
    isFullScreen() {
      return !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    },
  },
};
</script>


<style lang="scss" scoped>
.header {
  width: 100%;
  height: 58px;
  background-color: #0d6eb3;
  padding: 2px 0px;
  display: flex;
  align-items: center;

  .collapseBtn {
    margin-left: 16px;
    cursor: pointer;
    line-height: 58px;
  }

  .logoImg {
    width: 182px;
    height: 54px;
  }
  .title {
    color: white;
    font-size: 30px;
    line-height: 58px;
    font-weight: bold;
    margin-left: 20px;
  }

  .textImg {
    height: 54px;
  }

  .right {
    margin-left: auto;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    .screen {
      margin-right: 20px;
      cursor: pointer;
      color: white;
    }
  }
}
.el-dropdown {
  color: white;
}
</style>